const CARD_WIDTH = 1080;
const CARD_HEIGHT = 1350;
const MAX_CARD_A_ROWS = 27;

function escapeSvg(value) {
  return String(value == null ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function shortText(value, max = 40) {
  const text = String(value == null ? "" : value).trim();
  return text.length > max ? text.slice(0, Math.max(0, max - 3)) + "..." : text;
}

function isPickGame(game) {
  return String(game || "").toLowerCase().startsWith("pick");
}

function numbersFromRow(row) {
  if (Array.isArray(row)) return row;
  if (Array.isArray(row?.numbers)) return row.numbers;
  return [];
}

function rowIndex(row, fallback) {
  const value = Number(row?.index);
  return Number.isFinite(value) && value > 0 ? value : fallback + 1;
}

function numberLine(row, game) {
  return numbersFromRow(row)
    .map(value => {
      const text = String(value).trim();
      return isPickGame(game) ? text : text.padStart(2, "0");
    })
    .join("-");
}

function withCostSuffix(value) {
  const text = String(value || "$0").trim().replace(/\s+(estimated|cost)$/i, "");
  return (text || "$0") + " cost";
}

function fireballIconSvg(x, y) {
  return `<g data-fireball-icon="true" transform="translate(${x} ${y})"><path d="M15 34C6 31 1 24 3 15c1-5 4-9 8-13 0 6 3 9 6 11 2-5 5-9 10-13 0 8 5 12 8 18 5 10-2 20-12 17 4-3 5-8 2-13-2 4-5 6-9 8 1-4 0-7-3-10-3 5-3 10 2 14Z" fill="#ff6b00"/><path d="M18 34c-5-2-7-6-6-10 1-3 3-5 6-8 0 4 2 6 4 7 1-3 3-5 6-7 0 5 3 7 5 11 2 6-2 10-8 9 2-2 3-5 1-8-2 3-4 5-8 6Z" fill="#ffb000"/></g>`;
}

function renderCardANumberGrid({ rows, game, totalRows, rowSuffixes = [], rowFireballs = [] }) {
  const rendered = (Array.isArray(rows) ? rows : []).slice(0, MAX_CARD_A_ROWS);
  const columns = 3;
  const perColumn = Math.max(1, Math.ceil(rendered.length / columns));
  const rowHeight = 48;
  const colWidth = 292;
  const xStart = 126;
  const yStart = 520;
  const body = rendered.map((row, i) => {
    const col = Math.floor(i / perColumn);
    const idx = i - col * perColumn;
    const x = xStart + col * colWidth;
    const y = yStart + idx * rowHeight;
    const suffix = rowSuffixes[i] ? " " + String(rowSuffixes[i]) : "";
    const digits = numberLine(row, game) + suffix;
    const hasFireball = !!rowFireballs[i];
    const fireballX = x + 72 + Math.min(188, digits.length * 13 + 8);
    const compatibilityMarker = hasFireball ? `<tspan dx="0" font-size="0" fill="transparent">&#128293;</tspan>` : "";
    const fireballMark = hasFireball ? fireballIconSvg(fireballX, y - 35) : "";
    return `<rect x="${x}" y="${y - 27}" width="56" height="32" rx="11" fill="#D4AF37"/><text x="${x + 28}" y="${y - 4}" text-anchor="middle" font-family="Arial, sans-serif" font-size="20" font-weight="900" fill="#002855">#${rowIndex(row, i)}</text><text x="${x + 72}" y="${y - 4}" font-family="Arial, sans-serif" font-size="27" font-weight="900" fill="#ffffff">${escapeSvg(digits)}${compatibilityMarker}</text>${fireballMark}`;
  }).join("");
  return {
    shown: rendered.length,
    total: Number(totalRows) || rendered.length,
    svg: body,
  };
}

function renderMetricBox({ x, label, value, width = 284 }) {
  return `<rect x="${x}" y="1010" width="${width}" height="118" rx="26" fill="#002855"/><text x="${x + 24}" y="1052" font-family="Arial, sans-serif" font-size="19" font-weight="800" fill="#fff">${escapeSvg(label)}</text><text x="${x + 24}" y="1106" font-family="Arial, sans-serif" font-size="27" font-weight="900" fill="#D4AF37">${escapeSvg(value)}</text>`;
}

function renderCanonicalCardA(input = {}) {
  const accent = input.accent || "#008577";
  const game = input.game || "";
  const rows = Array.isArray(input.rows) ? input.rows : [];
  const numbers = renderCardANumberGrid({
    rows,
    game,
    totalRows: input.numbersTotal || rows.length,
    rowSuffixes: input.rowSuffixes || [],
    rowFireballs: input.rowFireballs || [],
  });
  const footerLink = String(input.footerLink || input.link || "www.lottotracker.app").replace(/^https?:\/\//, "");
  const combinations = shortText(input.combinationsLabel || `${input.numbersTotal || rows.length} combinations`, 24);
  const represented = shortText(input.representedLabel || `${input.representedPlayCount || rows.length} total plays`, 24);
  const cost = shortText(input.costLabel || withCostSuffix(input.estimatedCost), 20);
  const panelRows = Math.max(1, Math.ceil(numbers.shown / 3));
  const panelHeight = Math.max(300, Math.min(500, panelRows * 48 + 96));
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${CARD_WIDTH}" height="${CARD_HEIGHT}" viewBox="0 0 ${CARD_WIDTH} ${CARD_HEIGHT}">
  <defs><linearGradient id="bg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#002855"/><stop offset=".62" stop-color="#073b68"/><stop offset="1" stop-color="${escapeSvg(accent)}"/></linearGradient></defs>
  <rect width="${CARD_WIDTH}" height="${CARD_HEIGHT}" rx="58" fill="url(#bg)"/>
  <rect x="62" y="62" width="956" height="1226" rx="46" fill="#fffaf0" opacity=".99"/>
  <text x="110" y="158" font-family="Arial, sans-serif" font-size="48" font-weight="800" fill="#002855">Lotto<tspan fill="#D4AF37">Tracker</tspan></text>
  <text x="110" y="216" font-family="Arial, sans-serif" font-size="24" font-weight="800" fill="#008577" letter-spacing="5">WHAT I'M PLAYING TODAY</text>
  <text x="110" y="310" font-family="Arial, sans-serif" font-size="58" font-weight="900" fill="#002855">${escapeSvg(shortText(input.strategyName || input.title || "LottoTracker Strategy", 31))}</text>
  <text x="110" y="366" font-family="Arial, sans-serif" font-size="34" font-weight="900" fill="${escapeSvg(accent)}">${escapeSvg(shortText(input.gameLine || game, 48))}</text>
  <rect x="104" y="432" width="872" height="${panelHeight}" rx="28" fill="#002855"/>
  <text x="110" y="414" font-family="Arial, sans-serif" font-size="26" font-weight="800" fill="#555">${escapeSvg(shortText(input.rulesLine || "", 60))}</text>
  <text x="126" y="456" font-family="Arial, sans-serif" font-size="22" font-weight="900" fill="#008577">ACTUAL NUMBERS - ${numbers.shown} of ${numbers.total} shown</text>
  ${numbers.svg}
  ${renderMetricBox({ x: 110, label: "COMBINATIONS", value: combinations })}
  ${renderMetricBox({ x: 398, label: "TOTAL PLAYS", value: represented })}
  ${renderMetricBox({ x: 686, label: "COST", value: cost })}
  <text x="110" y="1192" font-family="Arial, sans-serif" font-size="35" font-weight="900" fill="#002855">Watch this draw on LottoTracker</text>
  <text x="110" y="1239" font-family="Arial, sans-serif" font-size="23" font-weight="900" fill="#008577">${escapeSvg(shortText(footerLink, 50))}</text>
  <text x="110" y="1275" font-family="Arial, sans-serif" font-size="18" font-weight="700" fill="#5a4a00">No ticket sales. No gambling. No money handled.</text>
</svg>`;
}

module.exports = {
  MAX_CARD_A_ROWS,
  renderCanonicalCardA,
  renderCardANumberGrid,
};
